function totalNumber(
  api,
  rowIndex,
  field,
  newValue,
  rows,
  baseRowUpdateObj
) {
  const maxTotal = 0 === rowIndex ? newValue : rows[0].data[field];

  const tempRowObj = Object.assign(
    {},
    baseRowUpdateObj,
    {
      percent: ((newValue / maxTotal) * 100).toFixed(2),
    }
  );

  api.setRowData(
    rows.reduce((acc, { data }, idx) => {
      let updatedRowObj = {};

      if (rowIndex === idx) {
        updatedRowObj = 0 === rowIndex ? baseRowUpdateObj : tempRowObj;
      } else {
        updatedRowObj = baseRowUpdateObj;
        updatedRowObj[field] = ((data.percent * maxTotal) / 100).toFixed(0);
      }

      acc.push(Object.assign({}, data, updatedRowObj));
      return acc;
    }, [])
  );
}

function percent(
  api,
  rowIndex,
  field,
  newValue,
  rows,
  baseRowUpdateObj
) {
  const tempRowObj = Object.assign(
    {},
    baseRowUpdateObj,
    {
      totalNumber: ((rows[0].data.totalNumber * newValue) / 100).toFixed(0),
    }
  );

  api.setRowData(
    rows.reduce((acc, { data }, idx) => {
      let updatedRowObj = {};

      if (rowIndex === idx) {
        updatedRowObj = 0 === rowIndex ? baseRowUpdateObj : tempRowObj;
      } else {
        updatedRowObj = baseRowUpdateObj;
        updatedRowObj[field] = data.percent;
      }

      acc.push(Object.assign({}, data, updatedRowObj));
      return acc;
    }, [])
  );
}

function technicalPricing(
  api,
  rowIndex,
  field,
  newValue,
  rows,
  baseRowUpdateObj,
  defaultData
) {
  const tempRowObj = Object.assign(
    {},
    baseRowUpdateObj,
    {
      technicalPricingPercent:
        (newValue / defaultData[rowIndex].technicalPricing) * 100,
    }
  );

  api.setRowData(
    rows.reduce((acc, { data }, idx) => {
      acc.push(Object.assign(
        {}, data, rowIndex === idx ? tempRowObj : {}
      ));
      return acc;
    }, [])
  );
}

function professionalPricing(
  api,
  rowIndex,
  field,
  newValue,
  rows,
  baseRowUpdateObj,
  defaultData
) {
  const tempRowObj = Object.assign(
    {},
    baseRowUpdateObj,
    {
      professionalPricingPercent:
        (newValue / defaultData[rowIndex].professionalPricing) * 100,
    }
  );

  api.setRowData(
    rows.reduce((acc, { data }, idx) => {
      acc.push(Object.assign(
        {}, data, rowIndex === idx ? tempRowObj : {}
      ));
      return acc;
    }, [])
  );
}

function technicalPricingPercent(
  api,
  rowIndex,
  field,
  newValue,
  rows,
  baseRowUpdateObj,
  defaultData
) {
  const tempRowObj = Object.assign(
    {},
    baseRowUpdateObj,
    {
      technicalPricing:
        (newValue / 100) * defaultData[rowIndex].technicalPricing,
    }
  );

  api.setRowData(
    rows.reduce((acc, { data }, idx) => {
      acc.push(Object.assign(
        {}, data, rowIndex === idx ? tempRowObj : {}
      ));
      return acc;
    }, [])
  );
}

function professionalPricingPercent(
  api,
  rowIndex,
  field,
  newValue,
  rows,
  baseRowUpdateObj,
  defaultData
) {
  const tempRowObj = Object.assign(
    {},
    baseRowUpdateObj,
    {
      professionalPricing:
        (newValue / 100) * defaultData[rowIndex].professionalPricing,
    }
  );

  api.setRowData(
    rows.reduce((acc, { data }, idx) => {
      acc.push(Object.assign(
        {}, data, rowIndex === idx ? tempRowObj : {}
      ));
      return acc;
    }, [])
  );
}

const updateTableRows = {
  totalNumber,
  percent,
  technicalPricing,
  professionalPricing,
  technicalPricingPercent,
  professionalPricingPercent,
};

export default updateTableRows;



// WEBPACK FOOTER //
// ./app/services/updateTableRows.js